import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const UpArrowIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={10}
      height={6}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53 5.406a.75.75 0 01-1.06 0L5 1.936l-3.47 3.47a.75.75 0 01-1.06-1.06l4-4a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default UpArrowIcon;
